import { EmployeeAnalytics } from 'components/employee-analytics/EmployeeAnalytics'

export const EmployeeAnalyticsContainer = () => {
    return <EmployeeAnalytics />
}
